// client/src/coms/views/canvas_parts/CanvasFillSettingsPanel.js
import React from 'react';

export default function CanvasFillSettingsPanel({
  bucketExpansion = 0,
  setBucketExpansion,
}) {
  const value = Math.max(-20, Math.min(20, Math.round(Number(bucketExpansion) || 0)));

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      padding: 12,
      borderRadius: 10,
      background: 'rgba(255,255,255,0.06)',
      border: '1px solid rgba(255,255,255,0.1)',
      minWidth: 0,
    }}>
      <div style={{ fontSize: 13, fontWeight: 700 }}>Fill edge</div>
      <label style={{ display: 'flex', flexDirection: 'column', gap: 7, fontSize: 12 }}>
        <span>Expand / retract: {value}px</span>
        <input
          type="range"
          min="-20"
          max="20"
          step="1"
          value={value}
          onChange={(event) => {
            if (typeof setBucketExpansion === 'function') {
              setBucketExpansion(Math.max(-20, Math.min(20, Math.round(Number(event.target.value) || 0))));
            }
          }}
        />
      </label>
      <div style={{ fontSize: 11, opacity: 0.72, lineHeight: 1.35 }}>
        Positive values grow beneath the outline. Negative values pull the fill back from it.
      </div>
    </div>
  );
}
